import { render } from "./Copyrights.vue?vue&type=template&id=c267bd38&scoped=true&ts=true"
import script from "./Copyrights.vue?vue&type=script&lang=ts"
export * from "./Copyrights.vue?vue&type=script&lang=ts"

import "./Copyrights.vue?vue&type=style&index=0&id=c267bd38&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c267bd38"]])

export default __exports__